export function organizationsNamespace(http) {
    return {
        /** List organizations the user belongs to → unwraps `data`. */
        list(opts) {
            return http.get('/organizations', { signal: opts?.signal });
        },
        /** One organization, with its collection quota → unwraps `data`. */
        get(organizationId, opts) {
            return http.get(`/organizations/${organizationId}`, { signal: opts?.signal });
        },
        /** Switch the active organization (raw — caller wants the whole body). */
        switch(organizationId) {
            return http.post(`/organizations/${organizationId}/switch`, { raw: true });
        },
        /** Members of one organization → unwraps to `{ users }`. */
        members(organizationId, opts) {
            return http.get(`/organizations/${organizationId}/users`, { signal: opts?.signal });
        },
        /**
         * Add a member. Identify them by `userId` or, when you only know their
         * address, by `email` — an organization admin cannot look up user ids.
         */
        addMember(organizationId, member) {
            return http.post(`/organizations/${organizationId}/users`, {
                body: {
                    ...(member.userId !== undefined ? { user_id: member.userId } : {}),
                    ...(member.email !== undefined ? { email: member.email } : {}),
                    role: member.role,
                },
            });
        },
        /** Change a member's role. */
        updateMemberRole(organizationId, userId, role) {
            return http.put(`/organizations/${organizationId}/users/${userId}`, { body: { role } });
        },
        /** Remove a member from the organization. */
        removeMember(organizationId, userId) {
            return http.delete(`/organizations/${organizationId}/users/${userId}`);
        },
    };
}
//# sourceMappingURL=organizations.js.map